import { z } from 'zod';

// Pezzature standard (Drive ARRAYLIST: 5/10/20/50/100g).
// SIEVED_FREE_SAMPLE ha solo 10g come campione gratuito.
export const productSkuGrammaturaSchema = z.union([
  z.literal(5),
  z.literal(10),
  z.literal(20),
  z.literal(50),
  z.literal(100),
]);
export type ProductSkuGrammatura = z.infer<typeof productSkuGrammaturaSchema>;

export const productSkuResponseSchema = z.object({
  id: z.string(),
  productId: z.string(),
  productCode: z.string(),
  productName: z.string(),
  grammatura: z.number().int(),
  sku: z.string(),
  ean: z.string().nullable(),
  active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ProductSkuResponse = z.infer<typeof productSkuResponseSchema>;

export const productSkuListQuerySchema = z.object({
  productId: z.string().uuid().optional(),
  grammatura: z.coerce.number().int().min(1).max(1000).optional(),
  sku: z.string().min(1).max(64).optional(),
  active: z.coerce.boolean().optional(),
});
export type ProductSkuListQuery = z.infer<typeof productSkuListQuerySchema>;

export const productSkuListResponseSchema = z.object({
  items: z.array(productSkuResponseSchema),
  total: z.number().int().nonnegative(),
});
export type ProductSkuListResponse = z.infer<typeof productSkuListResponseSchema>;
